module.exports = __webpack_public_path__ + "img/footer-logo.c3eff200.png";